import { useSearchParams } from "#routers/hooks";
import { useStorageKey } from "#src/hooks/useStorageKey";
import type { SortingType } from "@validereinc/common-components";
import {
  AssetType,
  SortDirection,
  type AssetTypeType,
} from "@validereinc/domain";
import React from "react";
import { NetworkDevicesPanel } from "./NetworkDevicesPanel";
import { NetworkEquipmentPanel } from "./NetworkEquipmentPanel";
import { NetworkFacilitiesPanel } from "./NetworkFacilitiesPanel";
import { NetworkFlowsPanel } from "./NetworkFlowsPanel";

export const NETWORK_ENTITY_INITIAL_SORT: SortingType = {
  sortBy: "name",
  sortDirection: SortDirection.ASCENDING,
};

export const NetworkEntityTablePanel = () => {
  const [searchParams] = useSearchParams<{ entity: AssetTypeType }>();
  const { entity } = searchParams || {};
  const [filterConfigStorageKey, tableConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["filter-configuration", "table-configuration", "table-state"],
      `networks-${entity}`
    );

  switch (entity) {
    case AssetType.FLOW:
      return (
        <NetworkFlowsPanel
          filterConfigStorageKey={filterConfigStorageKey}
          tableConfigStorageKey={tableConfigStorageKey}
          tableStateStorageKey={tableStateStorageKey}
        />
      );
    case AssetType.FACILITY:
      return (
        <NetworkFacilitiesPanel
          filterConfigStorageKey={filterConfigStorageKey}
          tableConfigStorageKey={tableConfigStorageKey}
          tableStateStorageKey={tableStateStorageKey}
        />
      );
    case AssetType.EQUIPMENT:
      return (
        <NetworkEquipmentPanel
          filterConfigStorageKey={filterConfigStorageKey}
          tableConfigStorageKey={tableConfigStorageKey}
          tableStateStorageKey={tableStateStorageKey}
        />
      );
    case AssetType.DEVICE:
      return (
        <NetworkDevicesPanel
          filterConfigStorageKey={filterConfigStorageKey}
          tableConfigStorageKey={tableConfigStorageKey}
          tableStateStorageKey={tableStateStorageKey}
        />
      );
    default:
      return null;
  }
};
